<div class="row">
  <div class="col-lg-2" style="background-color: #F2F2F2">
    <app-admin-menu></app-admin-menu>
  </div>
  <div class="col-lg-10" style="padding-top: 54px;">
    <div class="admin-main-container-content row">
      <div style = "margin-left: -2px;" class="header-title col-lg-12">{{'' | i18n: 'help-config'}}</div>
      <div class = "col-lg-2 btn-update">
        <button (click)="updateHelps()">{{'' | i18n: 'save'}}</button>
      </div>
      <div class="filter-container col-lg-12">
      <table>
        <tr>
          <td>
            <label>English</label><br>
            <input type="text" [(ngModel)]="englishHeader1.text">
            <textarea type="text" [(ngModel)]="englishText1.text" style="width: 300px; height: 200px"></textarea>
          </td>
          <td>
            <label>German</label><br>
            <input type="text" [(ngModel)]="germanHeader1.text">
            <textarea type="text" [(ngModel)]="germanText1.text" style="width: 300px; height: 200px"></textarea>
          </td>
          <td>
            <label>French</label><br>
            <input type="text" [(ngModel)]="frenchHeader1.text">
            <textarea type="text" [(ngModel)]="frenchText1.text" style="width: 300px; height: 200px"></textarea>
          </td>
          <td>
            <label>Dutch</label><br>
            <input type="text" [(ngModel)]="dutchHeader1.text">
            <textarea type="text" [(ngModel)]="dutchText1.text" style="width: 300px; height: 200px"></textarea>
          </td>
        </tr>
        <tr>
          <td>
            <input type="text" [(ngModel)]="englishHeader2.text">
            <textarea type="text" [(ngModel)]="englishText2.text" style="width: 300px; height: 200px"></textarea>
          </td>
          <td>
            <input type="text" [(ngModel)]="germanHeader2.text">
            <textarea type="text" [(ngModel)]="germanText2.text" style="width: 300px; height: 200px"></textarea>
          </td>
          <td>
            <input type="text" [(ngModel)]="frenchHeader2.text">
            <textarea type="text" [(ngModel)]="frenchText2.text" style="width: 300px; height: 200px"></textarea>
          </td>
          <td>
            <input type="text" [(ngModel)]="dutchHeader2.text">
            <textarea type="text" [(ngModel)]="dutchText2.text" style="width: 300px; height: 200px"></textarea>
          </td>
        </tr>
        <tr>
          <td>
            <input type="text" [(ngModel)]="englishHeader3.text">
            <textarea type="text" [(ngModel)]="englishText3.text" style="width: 300px; height: 200px"></textarea>
          </td>
          <td>
            <input type="text" [(ngModel)]="germanHeader3.text">
            <textarea type="text" [(ngModel)]="germanText3.text" style="width: 300px; height: 200px"></textarea>
          </td>
          <td>
            <input type="text" [(ngModel)]="frenchHeader3.text">
            <textarea type="text" [(ngModel)]="frenchText3.text" style="width: 300px; height: 200px"></textarea>
          </td>
          <td>
            <input type="text" [(ngModel)]="dutchHeader3.text">
            <textarea type="text" [(ngModel)]="dutchText3.text" style="width: 300px; height: 200px"></textarea>
          </td>
        </tr>
        <tr>
          <td>
            <input type="text" [(ngModel)]="englishHeader4.text">
            <textarea type="text" [(ngModel)]="englishText4.text" style="width: 300px; height: 200px"></textarea>
          </td>
          <td>
            <input type="text" [(ngModel)]="germanHeader4.text">
            <textarea type="text" [(ngModel)]="germanText4.text" style="width: 300px; height: 200px"></textarea>
          </td>
          <td>
            <input type="text" [(ngModel)]="frenchHeader4.text">
            <textarea type="text" [(ngModel)]="frenchText4.text" style="width: 300px; height: 200px"></textarea>
          </td>
          <td>
            <input type="text" [(ngModel)]="dutchHeader4.text">
            <textarea type="text" [(ngModel)]="dutchText4.text" style="width: 300px; height: 200px"></textarea>
          </td>
        </tr>
        <tr>
          <td>
            <input type="text" [(ngModel)]="englishHeader5.text">
            <textarea type="text" [(ngModel)]="englishText5.text" style="width: 300px; height: 200px"></textarea>
          </td>
          <td>
            <input type="text" [(ngModel)]="germanHeader5.text">
            <textarea type="text" [(ngModel)]="germanText5.text" style="width: 300px; height: 200px"></textarea>
          </td>
          <td>
            <input type="text" [(ngModel)]="frenchHeader5.text">
            <textarea type="text" [(ngModel)]="frenchText5.text" style="width: 300px; height: 200px"></textarea>
          </td>
          <td>
            <input type="text" [(ngModel)]="dutchHeader5.text">
            <textarea type="text" [(ngModel)]="dutchText5.text" style="width: 300px; height: 200px"></textarea>
          </td>
        </tr>
      </table>

    </div></div>
  </div>
</div>
